module.exports = __webpack_public_path__ + "img/mobile.82316712.jpg";